import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * Accessible modal component
 */
@Component({ name: 'Modal' })
export default class default_1 extends Vue {
    @Prop({ required: true })
    modal;
    @Prop({ required: true })
    disabled;
    open = false;
    transitionOpen = false;
    mounted() {
        const modal = this.$refs.modal;
        // Besides adding `open` attribute the modal, `.showModal()` also:
        // - ensures that the modal appear above any other content by putting it in the `#top-layer`
        // - prevents interaction with any other elements outsides of the modal
        if (modal.showModal) {
            modal.showModal();
        }
        else {
            // .showModal is not supported in iOS < 15.4
            // fallback to using the 'open' attribute to open the modal
            this.open = true;
        }
        // Defer setting the `transitionOpen` property:
        // This property controls the CSS `open` class, which triggers a transition.
        // It must not be set in the same DOM update cycle as `mounted`,
        // or the transition will not be applied correctly.
        this.$nextTick(() => {
            this.transitionOpen = true;
        });
        const style = document.body.style;
        const modalHeaderEl = this.$el.querySelector('.mobile-cart .modal-header');
        if (modalHeaderEl != null) {
            style.setProperty('--modal-header-height', `${modalHeaderEl.offsetHeight}px`);
        }
    }
    close() {
        if (this.modal.closeable) {
            this.transitionOpen = false;
            const waitForCssTransitionDelay = parseInt(document.documentElement.style.getPropertyValue('--modal-transition-duration'), 10);
            setTimeout(() => {
                this.$emit('close');
            }, waitForCssTransitionDelay);
        }
    }
    get classes() {
        const mobileClass = `mobile-${this.modal.mobile}`;
        const desktopClass = `desktop-${this.modal.desktop}`;
        return [
            'modal',
            this.modal.size,
            this.modal.name,
            mobileClass,
            desktopClass,
            { disabled: this.disabled },
            { open: this.transitionOpen },
        ];
    }
    get closeOnBackdropClick() {
        return this.modal.closeOnBackdropClick ?? true;
    }
    handleBackdropClick(e) {
        if (this.closeOnBackdropClick && e.target === e.currentTarget)
            this.close();
    }
}
